import React from "react";
import { useNavigate } from "react-router-dom";
import "./EatsAdminCreatePage.css";

const EatsAdminPageHeader = ({
  title,
  subtitle,
  beforeTitle = null,
  homeTo = "/eats/admin",
  onHome,
  backTo,
  onBack,
  actions = null,
}) => {
  const navigate = useNavigate();

  return (
    <div className="eats-admin-create-header">
      <div>
        {beforeTitle}
        {title ? <h2 className="eats-admin-create-title">{title}</h2> : null}
        {subtitle ? <p className="eats-admin-create-subtitle">{subtitle}</p> : null}
      </div>
      <div className="eats-admin-create-header-actions">
        {actions}
        <button
          type="button"
          className="eats-admin-header-btn"
          onClick={() => (onHome ? onHome() : navigate(homeTo))}
        >
          Home
        </button>
        <button
          type="button"
          className="eats-admin-header-btn"
          onClick={() => (onBack ? onBack() : backTo ? navigate(backTo) : navigate(-1))}
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default EatsAdminPageHeader;
